import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { footer } from "../mock";

const InstagramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);
const YoutubeIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.4a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
  </svg>
);
const TwitterIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
  </svg>
);

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) setSubscribed(true);
  };

  return (
    <footer className="bg-[#050304] text-white/80">
      {/* Newsletter */}
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-12 flex flex-col items-center text-center">
          <h3 className="font-serif text-2xl text-[#F3E7D8]">Join the Deegford Circle</h3>
          <p className="mt-2 text-sm text-white/60 max-w-md">
            Subscribe for early access to new launches, exclusive offers and fragrance tips.
          </p>
          {subscribed ? (
            <p className="mt-5 text-[#FFE29A] font-medium">Thank you for subscribing! ✨</p>
          ) : (
            <form onSubmit={handleSubscribe} className="mt-5 flex w-full max-w-md gap-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 bg-transparent border border-white/25 rounded-sm px-4 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[#FFE29A] transition-colors"
              />
              <button
                type="submit"
                className="bg-gradient-to-br from-[#FFE29A] to-[#C8932F] text-[#050304] px-6 py-3 text-sm font-semibold uppercase tracking-widest rounded-sm hover:opacity-90 transition-opacity"
              >
                Subscribe
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Columns */}
      <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <img src="/logo.png" alt="Deegford" className="h-16 w-auto object-contain mb-4" />
          <p className="mt-2 text-sm leading-relaxed text-white/60 max-w-sm">{footer.about}</p>
          <div className="mt-6 flex items-center gap-4">
            {[InstagramIcon, FacebookIcon, YoutubeIcon, TwitterIcon].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="social"
                className="h-9 w-9 rounded-full border border-white/20 flex items-center justify-center hover:border-[#FFE29A] hover:text-[#FFE29A] transition-colors"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        {footer.columns.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-[#F3E7D8] mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link}>
                  <Link to="/collections/all" className="text-sm text-white/60 hover:text-[#FFE29A] transition-colors">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Contact strip */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Deegford Fine Fragrances. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> care@deegford.com</span>
            <span className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5" /> +91 98765 43210</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
